var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_640_330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6663 25.3333C30.6663 26.0406 30.3854 26.7189 29.8853 27.219C29.3852 27.719 28.7069 28 27.9997 28H3.99967C3.29243 28 2.61415 27.719 2.11406 27.219C1.61396 26.7189 1.33301 26.0406 1.33301 25.3333V10.6667C1.33301 9.95942 1.61396 9.28115 2.11406 8.78105C2.61415 8.28095 3.29243 8 3.99967 8H9.33301L11.9997 4H19.9997L22.6663 8H27.9997C28.7069 8 29.3852 8.28095 29.8853 8.78105C30.3854 9.28115 30.6663 9.95942 30.6663 10.6667V25.3333Z",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 22.6667C18.9452 22.6667 21.333 20.2789 21.333 17.3333C21.333 14.3878 18.9452 12 15.9997 12C13.0542 12 10.6663 14.3878 10.6663 17.3333C10.6663 20.2789 13.0542 22.6667 15.9997 22.6667Z",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_640_330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.4187734a3d4ad83a4cdf66969b891b30.svg";
export { ForwardRef as ReactComponent };